import React from 'react'
import PlaceholderPage from '../../components/shared/PlaceholderPage'
import { Briefcase } from 'lucide-react'

const features = [
  { name: 'Project Details', description: 'Set project name, description, and dates' },
  { name: 'Customer Link', description: 'Associate project with a customer' },
  { name: 'Milestone Setup', description: 'Define key milestones and deadlines' },
  { name: 'Team Selection', description: 'Assign initial team members' },
]

export default function ProjectCreateView() {
  return (
    <PlaceholderPage
      title="Create Project"
      description="Start a new customer project"
      icon={Briefcase}
      features={features}
      accentColor="emerald"
    />
  )
}
